/**
 * hb-swiper-gap.js — separacio entre slides dels carrusels de producte.
 *
 * PER QUE EXISTEIX AQUEST FITXER
 * Swiper escriu `margin-right` INLINE a cada `.swiper-slide` a partir de
 * l'opcio `spaceBetween`, i calcula l'amplada dels slides amb aquest mateix
 * numero. Per tant NO es pot corregir des del CSS: un override del margin
 * desquadraria l'amplada calculada i trencaria el carrusel.
 *
 * El valor viu a `theme.js` (theme.initProductSlider, ~linia 5295):
 *   spaceBetween: 20        <- valor base
 *   breakpoints 767:  10    <- mobil
 *   breakpoints 3000: 20    <- pantalles molt amples
 *
 * Editar `theme.js` directament funcionaria, pero es un fitxer del tema
 * Showcase: al proper update es sobreescriuria i el canvi es perdria. Per
 * aixo aqui embolcallem el constructor global `Swiper` i injectem el valor
 * nou just abans que s'instanciï. `theme.js` queda intacte i el canvi
 * sobreviu a les actualitzacions del tema.
 *
 * Carrega a layout/theme.liquid ENTRE vendor.min.js (que defineix Swiper) i
 * theme.js (que l'instancia). Els tres son `defer`, per tant s'executen en
 * ordre de document.
 */
(function () {
  'use strict';

  var GAP = 2; // px entre slides (era 20 / 10 segons breakpoint; despres 4)

  if (typeof window.Swiper !== 'function') return;

  var OriginalSwiper = window.Swiper;

  function applyGap(options) {
    if (!options || typeof options !== 'object') return options;

    // Nomes toquem carrusels que ja declaraven una separacio. Els que van a 0
    // (galeria de fitxa de producte, per exemple) han de seguir a 0.
    if (typeof options.spaceBetween === 'number' && options.spaceBetween > 0) {
      options.spaceBetween = GAP;
    }

    // Els breakpoints sobreescriuen el valor base; cal fer-los tots.
    if (options.breakpoints && typeof options.breakpoints === 'object') {
      Object.keys(options.breakpoints).forEach(function (bp) {
        var conf = options.breakpoints[bp];
        if (conf && typeof conf.spaceBetween === 'number' && conf.spaceBetween > 0) {
          conf.spaceBetween = GAP;
        }
      });
    }

    return options;
  }

  function PatchedSwiper(el, options) {
    return new OriginalSwiper(el, applyGap(options));
  }

  // Conserva propietats estatiques (Swiper.use, Swiper.prototype...) i la
  // cadena de prototips, perque el codi del tema segueixi funcionant igual.
  PatchedSwiper.prototype = OriginalSwiper.prototype;
  Object.keys(OriginalSwiper).forEach(function (key) {
    PatchedSwiper[key] = OriginalSwiper[key];
  });

  window.Swiper = PatchedSwiper;
})();
